import React from "react";

import {
  /*HomeOutlined,*/ UserOutlined,
  CalculatorOutlined,
  UsergroupAddOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
// import { Dashboard } from '../pages/dashboard';
import { MedicalReports } from "../pages/medical-reports";
import { Schedule } from "../pages/schedule";

import { Patients } from "../pages/patitents";
import { ReportTypes } from "../pages/report-types";
import { AddOrEditMedicalReport } from "../pages/medical-reports/components/AddOrEditMedicalReport";
import { UserProfile } from '../pages/general/index';
import { Spinner } from "../components/Spinner";
export const appRoutes = [
  // {
  //   title: 'Kontrolna tabla',
  //   path: '/',
  //   component: Dashboard,
  //   icon: <HomeOutlined />
  //   // permission_name: 'view_dashboard'
  // },
  {
    title: "",
    path: "/",
    component: Spinner,
    permission_name: ['loading'],
    skipRender: true,
  },
	/*
  {
    title: "Izvještaji",
    path: "/",
    component: MedicalReports,
    icon: <FileTextOutlined />,
		skipRender: true,
    permission_name: ['D']
  },
	*/
  {
    title: "Izvještaji",
    path: "/medical-reports",
    component: MedicalReports,
    icon: <FileTextOutlined />,
    permission_name: ['D']
  },
  {
    title: "Zakazani pregledi",
    path: "/",
    component: Schedule,
    icon: <CalculatorOutlined />,
    permission_name: ['N']
  },
  {
    title: "Zakazani pregledi",
    path: "/",
    component: Schedule,
    icon: <CalculatorOutlined />,
		skipRender: true,
    permission_name: ['D']
  },
  {
    title: "Zakazani pregledi",
    path: "/schedule-reports",
    component: Schedule,
    icon: <CalculatorOutlined />,
    permission_name: ['D']
  },
  {
    title: "Dodaj izvještaj",
    path: "/medical-reports/add",
    component: AddOrEditMedicalReport,
    permission_name: ['D','N'],
    skipRender: true,
  },
  {
    title: "Uredi izvještaj",
    path: "/medical-reports/edit/:id",
    component: AddOrEditMedicalReport,
    permission_name: ['D','N'],
    skipRender: true,
  },
  {
    title: "Pacijenti",
    path: "/patients",
    component: Patients,
    icon: <UsergroupAddOutlined />,
    permission_name: ['D','N']
  },
  {
    title: "Pregledi",
    path: "/report-types",
    component: ReportTypes,
    icon: <CalculatorOutlined />,
    permission_name: ['D','N']
  },
  {
    title: "Profil",
    path: "/my-profile",
    component: UserProfile,
    icon: <UserOutlined />,
    permission_name: ['all']
  },
];

// TO DO - when permission finished on backend add logic for route permission
//TODO popraviti kada se rifresuje stranica 
export const getAllowedRoutes = (type) => {
  let role = type
  if(role){
  return appRoutes.filter((elem)=>{
    return (elem.permission_name.includes(role)|| elem.permission_name.includes('all'))
   })
}else{
   return appRoutes
}
};
